
import React from "react";
import { object } from "prop-types";
import "./comment-icon.m.css";

const CommentIcon = ({ storyObj }) => {
  const isCommentingOn = storyObj && storyObj.metadata && storyObj.metadata["story-attributes"] && storyObj.metadata["story-attributes"].kommentointi && storyObj.metadata["story-attributes"].kommentointi[0] || "";
  return (
    ((storyObj && storyObj["story-template"] !== "wau-juttu" && storyObj["story-template"] !== "natiivi") && isCommentingOn !== "pois" ) &&
    <i
      className="ri-chat-1-line"
      styleName="comment-icon"
      title="Artikkelia voi kommentoida"
      aria-label="Artikkelia voi kommentoida"
    ></i>
  );
};
CommentIcon.propTypes = {
  storyObj: object
};
export { CommentIcon };
